import * as React from "react";

/** Bowl icon — 1 L fill level */
export function Bowl1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={9}
      viewBox="0 0 24 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9958 7.25941C14.3828 7.25941 20.1799 7.25941 22.0209 7.25941C20.8159 4.94979 19.9791 2.87448 19.0418 1H5.05021C4.11297 2.90795 3.10879 4.98326 2.03766 7.25941C3.81172 7.25941 9.60887 7.25941 11.9958 7.25941Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7.28452H22.9582"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Bowl icon — 1.5 L fill level */
export function Bowl2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={11}
      viewBox="0 0 24 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9958 9.8932C14.3828 9.8932 20.1799 9.8932 22.0209 9.8932C20.8159 6.61175 19.9791 3.66321 19.0418 1H5.05021C4.11297 3.71076 3.10879 6.65931 2.03766 9.8932C3.81172 9.8932 9.60887 9.8932 11.9958 9.8932Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 9.92887H22.9582"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Bowl icon — 3 L fill level */
export function Bowl3(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={15}
      viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9958 13.0938C14.3828 13.0938 20.1799 13.0938 22.0209 13.0938C20.8159 8.63136 19.9791 4.62166 19.0418 1H5.05021C4.11297 4.68633 3.10879 8.69603 2.03766 13.0938C3.81172 13.0938 9.60887 13.0938 11.9958 13.0938Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 13.1423H22.9582"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}
